import React from 'react'
import AlumniHomePage from './AlumniHomePage'
import ContactUsPage from '../ContactUsComponents/ContactUsPage'

export default function HomePage() {
  return (
    <div>
      
      <AlumniHomePage/>
      <ContactUsPage/>
    </div>
  )
}
